var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"single-client-logo-box"},[_c('a',{attrs:{"href":"#!"}},[_c('figure',[_c('b-img',{attrs:{"src":_vm.logoImg,"img-alt":_vm.altText}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }